import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/auth";
import LoginPage from "@/pages/Login";
import RegisterPage from "@/pages/Register";
import ForgotPasswordPage from "@/pages/Forgot";
import VerifyPage from "@/pages/Verify";
import LandingPage from "@/pages/Landing";
import StorePage from "@/pages/Store";
import MesLicences3PPage from "@/pages/MesLicences3P";
import ContactRevendeurPage from "@/pages/ContactReseller";
import AppLayout from "@/pages/Layout";
import Dashboard from "@/pages/Dashboard";
import LicencesPage from "@/pages/Licences";
import HistoriquePage from "@/pages/Historique";
import ParametresPage from "@/pages/Parametres";
import AdminPage from "@/pages/Admin";
import FirmwarePage from "@/pages/Firmware";
import PaiementsPage from "@/pages/Paiements";
import PilotesPage from "@/pages/Pilotes";
import "@/i18n";
import { Toaster } from "sonner";
import "@/index.css";

function Protected({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-black flex items-center justify-center text-orange-500 font-mono-tech">Chargement…</div>;
  if (!user) return <Navigate to="/welcome" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/welcome" element={<LandingPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot" element={<ForgotPasswordPage />} />
          <Route path="/verify" element={<VerifyPage />} />
          <Route path="/pilotes" element={
            <div className="min-h-screen bg-black text-white">
              <header className="border-b border-zinc-900">
                <div className="max-w-6xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between">
                  <a href="/welcome" data-testid="pilotes-home-link" className="font-display font-extrabold tracking-widest">LHS<span className="text-orange-500">UNLOCKER</span></a>
                  <a href="/welcome" data-testid="pilotes-back-link" className="text-sm text-zinc-400 hover:text-orange-400">← Retour à l'accueil</a>
                </div>
              </header>
              <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8"><PilotesPage publicMode /></main>
            </div>} />
          <Route element={<Protected><AppLayout /></Protected>}>
            <Route index element={<Dashboard />} />
            <Route path="store" element={<StorePage />} />
            <Route path="mes-licences-tierces" element={<MesLicences3PPage />} />
            <Route path="contact-revendeur" element={<ContactRevendeurPage />} />
            <Route path="firmware" element={<FirmwarePage />} />
            <Route path="licences" element={<LicencesPage />} />
            <Route path="paiements" element={<PaiementsPage />} />
            <Route path="historique" element={<HistoriquePage />} />
            <Route path="parametres" element={<ParametresPage />} />
            <Route path="admin" element={<Protected adminOnly><AdminPage /></Protected>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
